<template>
  <div>
    <v-form data-vv-scope="form" lazy-validation>
      <label class="caption mb-2">{{ label }}</label>
      <v-file-input
        v-model="file"
        :prepend-icon="iconLeft"
        :append-icon="iconRight"
        dense
        outlined
        show-size
        :placeholder="`Pilih file dengan format (${accept.join(',')})`"
        :accept="accept.join(',')"
        :hint="`Jenis file unggahan dengan format (${accept.join(',')}) minimal ${min}kb maks ${roundDecimal(
          max / 1000
        ).toFixed(1)} MB`"
        :rules="[
          (value) =>
            !value ||
            (value && value.size < roundDecimal(max * 1000)) ||
            (value && value.size < roundDecimal(min * 1000)) ||
            'File yang Anda pilih melebihi kapasitas maksimum!',
        ]"
        persistent-hint
        :disabled="readonly"
        :data-vv-name="required ? `${requiredName}` : ``"
        :data-vv-as="required ? `${requiredName.replace('_', ' ')}` : ``"
        v-validate="required ? 'required' : ''"
        :error-messages="required ? errors.collect(`form.${requiredName}`) : errorMessages"
        @change="onCheck"
      >
      </v-file-input>
    </v-form>
  </div>
</template>
<script>
export default {
  props: {
    max: {
      type: Number,
      default: 1500,
    },
    min: {
      type: Number,
      default: 20,
    },
    accept: {
      type: Array,
      default: () => [],
    },
    label: {
      type: String,
      default: '',
    },
    iconRight: {
      type: String,
      default: '',
    },
    iconLeft: {
      type: String,
      default: '',
    },
    errorMessages: {
      type: Array,
      default: () => [],
    },
    readonly: {
      type: Boolean,
      default: () => false,
    },
    required: {
      type: Boolean,
      default: false,
    },
    requiredName: {
      type: String,
      default: () => 'file',
    },
  },
  data() {
    return {
      file: null,
    }
  },
  methods: {
    roundDecimal(number) {
      return Math.round((number + Number.EPSILON) * 100) / 100
    },

    onCheck() {
      this.$emit('input', this.file)
    },

    async validate() {
      return await this.$validator.validateAll('form')
    }
  },
}
</script>
